








exports.default =
  props: ['kind', 'filter_item_selected_ids', 'uncheck_all_items', 'position', 'index']

  components:
    tagFilter: require('./dropdown_multiple_kind/tag_filter')
    stageFilter: require('./dropdown_multiple_kind/stage_filter')

  data: ->
    selected_items: []

  methods:
    dropdownComponent: (kind)->
      switch kind
        when 'tag_filter' then 'tag-filter'
        when 'stage_filter' then 'stage-filter'
        else ''

    itemSelectedItems: (data)->
      @selected_items = data.selected_items
      data.position = @position
      @$emit 'item-selected-items', data



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/dropdown-multiple-select.vue